import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import {Transportadora} from "../../types/AbaTransportadora";
import {sobrescreverInformacoesAction} from "../../redux/orcamentoSlice";
import { IOrcamento } from "app/types/IOrcamento";

declare var window:any

type DefinirTransportadoraInput = {
    identificadorOrcamento: string,
    tipoOrcamento: number,
    transportadora: Transportadora
}

export async function DefinirTransportadora(input: DefinirTransportadoraInput) {
    const resposta = await microuniversoApi.Orcamento.definirTransportadora(
        input.identificadorOrcamento,
        input.tipoOrcamento,
        input.transportadora
    )


    const orcamentoLegado = window.orcamentoController.model

    orcamentoLegado.atualizar({
        ...resposta.Transportadora,
        ItensOrcamento: resposta.ItensOrcamento,
    } as IOrcamento, true, true)

    return resposta.Transportadora;
}
